<template>
  <div class="app-container">
    <el-row :gutter="20">
      <el-col :span="24" :xs="24">
        <!-- 搜索表单 -->
        <el-form :model="queryParams" ref="queryForm" size="small" v-show="showSearch" label-width="100px">
          <el-row :gutter="24" type="flex" justify="right">
            <el-col :span="8">
              <el-form-item label="收款日期" prop="receiptTime">
                <el-date-picker v-model="queryParams.receiptTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="开始日期" value-format="yyyy-MM-dd" style="width: 100%;"
                                @change="handleSearch" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="客户名称" prop="compNames">
                <el-input v-model="queryParams.compNames" placeholder="请输入客户名称" clearable @keyup.enter.native="handleSearch" />
                <CustomerDetails v-model="queryParams.compNames" />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 功能按钮区域 -->
          <div style="text-align: center;margin-bottom: 10px;">
            <PermissionMethodToolbar :url="url" :id="'toolbar'" @handleSearch="handleSearch" @handleReset="handleReset" @exportToExcel="exportToExcel" />
          </div>

          <!-- 数据表格（无合计行） -->
          <el-table id="table" :data="tableData" border style="width: 100%; margin-top: 20px" :header-cell-style="{ background: '#d8e8fb', textAlign: 'left', borderColor: '#CCC' }" height="500"
                    v-loading="loading">
            <el-table-column type="index" label="序号" width="60" align="center" />
            <el-table-column label="客户名称" align="left" prop="compName" min-width="160" show-overflow-tooltip />
            <el-table-column label="使用单位" align="left" prop="usingUnit" min-width="160" show-overflow-tooltip />
            <el-table-column label="收款日期" align="left" prop="receiptTime" min-width="140" show-overflow-tooltip />
            <el-table-column label="收款金额" align="left" prop="actualReceiptAmount" min-width="120" show-overflow-tooltip />
            <el-table-column label="收款账号" align="left" prop="receiptMethod" min-width="140" show-overflow-tooltip />
            <el-table-column label="收款公司" align="left" prop="receiptCompany" min-width="160" show-overflow-tooltip />
          </el-table>

          <!-- 分页组件 -->
          <el-pagination style="margin-top: 10px; text-align: right;" @size-change="handleSizeChange" @current-change="handlePageChange" :current-page="queryParams.currPage"
                         :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" />
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { queryReceiptSheet, exportReceiptSheet } from '@/api/contract/contract'
import PermissionMethodToolbar from '@/components/button/PermissionMethodToolbar.vue'

export default {
  name: 'CollectionStatistics',
  props: {
    // 页面URL，用于权限按钮组件
    url: {
      type: String,
      default: ''
    }
  },
  components: {
    PermissionMethodToolbar
  },
  data () {
    return {
      showSearch: true,
      loading: false,
      tableData: [],
      queryParams: {
        compNames: '',
        receiptTime: [],
        currPage: 1,
        pageSize: 200
      },
      total: 0
    }
  },
  created () {
    this.getList()
  },
  methods: {
    buildParams () {
      const params = {
        currPage: this.queryParams.currPage,
        pageSize: this.queryParams.pageSize
      }

      if (this.queryParams.compNames) {
        params.compNames = this.queryParams.compNames
      }

      if (Array.isArray(this.queryParams.receiptTime) && this.queryParams.receiptTime.length === 2) {
        params.receiptTime = this.queryParams.receiptTime
      }

      return params
    },

    normalizeList (res) {
      // 兼容后端返回：{ retCode:'ok', additionalData: { list/records } } 或者 additionalData 直接是数组
      if (res && res.retCode === 'ok') {
        const ad = res.additionalData
        if (Array.isArray(ad)) return ad
        if (ad && Array.isArray(ad.records)) return ad.records
        if (ad && Array.isArray(ad.list)) return ad.list
        return []
      }

      // 兜底：直接返回数组
      if (Array.isArray(res)) return res
      if (res && Array.isArray(res.additionalData)) return res.additionalData
      return []
    },

    // 查询按钮
    handleSearch () {
      // 查询从第一页开始
      this.queryParams.currPage = 1
      this.getList()
    },

    // 重置按钮
    handleReset () {
      this.queryParams.compNames = ''
      this.queryParams.receiptTime = []
      this.queryParams.currPage = 1
      this.getList()
    },

    // 修改每页条数
    handleSizeChange (size) {
      this.queryParams.pageSize = size
      this.queryParams.currPage = 1
      this.getList()
    },

    // 分页切换页码
    handlePageChange (page) {
      this.queryParams.currPage = page
      this.getList()
    },

    // 列表查询
    getList () {
      this.loading = true
      const params = this.buildParams()

      queryReceiptSheet(params).then(res => {
        // 处理分页信息
        if (res && res.retCode === 'ok' && res.additionalData) {
          const ad = res.additionalData
          this.total = ad.total || 0
          if (ad.current !== undefined) {
            this.queryParams.currPage = ad.current
          }
          if (ad.size !== undefined) {
            this.queryParams.pageSize = ad.size
          }
        }

        const list = this.normalizeList(res) || []
        this.tableData = list
        this.loading = false
      }).catch(error => {
        console.error('查询失败:', error)
        this.$message.error('查询失败：' + (error.message || '未知错误'))
        this.tableData = []
        this.loading = false
      })
    },

    // 导出
    exportToExcel () {
      this.$message.success('正在导出收款统计数据...')
      const params = this.buildParams()

      exportReceiptSheet(params).then(response => {
        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = window.URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = url
        link.download = '收款统计.xlsx'

        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)

        this.$message.success('导出成功')
      }).catch(error => {
        console.error('导出失败:', error)
        this.$message.error('导出失败：' + (error.message || '未知错误'))
      })
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
}
</style>